import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from '..';

const propTypes = {
  action: PropTypes.shape({
    content: PropTypes.string,
    onAction: PropTypes.func,
  }).isRequired,
  enabled: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

const defaultProps = {
  children: null,
};

export default function SettingToggle({ action, enabled }) {
  const { content, onAction } = action;
  const primary = {
    primary: enabled,
  };
  return (
    <Button onClick={onAction} {...primary}>{content}</Button>
  );
}
SettingToggle.propTypes = propTypes;
SettingToggle.defaultProps = defaultProps;
